import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';

/**
 * # BusinessSubList
 *
 * BusinessSubList 설명하세요.
 */
export const BusinessSubList = types
  .model('BusinessSubList')
  .props({
    businessSid: types.maybeNull(types.number),
    businessSubSid: types.maybeNull(types.number),
    title: types.maybeNull(types.string),
    descript: types.maybeNull(types.string),
    desktopImgPath: types.optional(types.array(types.string), []),
    mobileImgPath: types.optional(types.array(types.string), []),
  })
  .volatile(() => ({
    // 데스크탑 이미지
    desktopImageFiles: [] as File[],
    deleteDesktopImageFiles: [] as string[],
    // 모바일 이미지
    mobileImageFiles: [] as File[],
    deleteMobileImageFiles: [] as string[],
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TBusinessSubList = Instance<typeof BusinessSubList>;
type TBusinessSubListSnapshot = SnapshotOut<typeof BusinessSubList>;

export interface IBusinessSubList extends TBusinessSubList {}
export type TBusinessSubListKeys = keyof TBusinessSubListSnapshot & string;
export interface IBusinessSubListSnapshot extends TBusinessSubListSnapshot {}
export const createBusinessSubList = (): IBusinessSubList => {
  return BusinessSubList.create({
    title: '',
    descript: '',
    desktopImgPath: [],
    mobileImgPath: [],
  });
};
